
import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { FaStar, FaCodeBranch } from 'react-icons/fa';

const FaStarIcon = FaStar as any;
const FaCodeBranchIcon = FaCodeBranch as any;

const githubRepos = [
  {
    name: 'netblock-tools',
    description: 'Set of tools for anti DDOS attacks protection on shared/dedicated hosting.',
    link: 'https://github.com/scopenco/netblock-tools',
    stars: 11,
    forks: 12
  },
  {
    name: 'kitchen-chefzero-nodes',
    description: 'Test Kitchen provisioner based on chef_zero that generates searchable nodes.',
    link: 'https://github.com/scopenco/kitchen-chefzero-nodes',
    stars: 8,
    forks: 1
  },
  {
    name: 'M202',
    description: 'M202: MongoDB Advanced Deployment and Operations (March 2016).',
    link: 'https://github.com/scopenco/M202',
    stars: 8,
    forks: 10
  },
  {
    name: 'build-tools',
    description: 'Construct custom yum repository from any of public repositories on the base of xml descriptions.',
    link: 'https://github.com/scopenco/build-tools',
    stars: 6,
    forks: 0
  },
  {
    name: 'zkTLS-Reclaim-demo',
    description: 'Demo for making a Revolut payment and verify it with zkTLS-based proof.',
    link: 'https://github.com/scopenco/zkTLS-Reclaim-demo',
    stars: 1,
    forks: 1
  },
  {
    name: 'solana_transfer_demo',
    description: 'Demo for sending SOL with Anchor + Phantom in Devnet.',
    link: 'https://github.com/scopenco/solana_transfer_demo',
    stars: 1,
    forks: 0
  }
].sort((a, b) => b.stars - a.stars).slice(0, 6);

const GitHub: React.FC = () => {
  return (
    <section id="github" className="py-5">
      <Container>
        <h2 className="text-center mb-4">GitHub Repositories</h2>
        <Row>
          {githubRepos.map((repo, index) => (
            <Col md={4} key={index} className="mb-4">
              <a href={repo.link} target="_blank" rel="noopener noreferrer" className="text-decoration-none">
                <Card className="h-100 github-repo-card">
                  <Card.Body>
                    <Card.Title>{repo.name}</Card.Title>
                    <Card.Text>{repo.description}</Card.Text>
                    <Card.Text>
                      <FaStarIcon /> {repo.stars} | <FaCodeBranchIcon /> {repo.forks}
                    </Card.Text>
                  </Card.Body>
                </Card>
              </a>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default GitHub;
